import React from "react";
import {Form, Input, message, Select} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import UserPresenter from "../../.gen/presenter/UserPresenter";
import PlatformPresenter from "../../.gen/presenter/PlatformPresenter";

export default class UserFormContent extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            company: [], //单位list
            roleList: [], //角色list
        };
        this.userPresenter = new UserPresenter(this);
        this.platformPresenter = new PlatformPresenter(this)

    }

    componentDidMount() {
        let {isEdit, userId} = this.props;
        if (isEdit) {
            this._loadUserDetailInfo(userId);
        }
        let loginUser = window._workbench._user;
        this._findPlatformRoleList(loginUser.platform);

    }


    //根据platform查询出平台角色
    _findPlatformRoleList(platform) {
        this.platformPresenter.findPlatformRoleList(
            {platform: platform},
            {},
            (result) => {
                let {data} = result;
                this.setState({roleList: data})
            }
        )
    }

    //编辑时，加载用户详情
    _loadUserDetailInfo(userId) {
        this.userPresenter.getUser(
            {accountId: userId},
            {},
            (result) => {
                let {data} = result;
                if (data) {
                    this._findPlatformRoleList(data.platform); //查询角色列表
                    this.form.setFieldsValue({
                        orgParentId: data.orgParentId,
                        name: data.name,
                        email: data.email,
                        mobile: data.mobile,
                        account: data.account,
                        orgId: data.orgId,
                        orgName: data.orgName,
                        staffId: data.staffId
                    });
                }
            },
            (result) => {
                let {message} = result;
                this.toastFail(message)
            }
        )
    }


    render() {
        let {isEdit} = this.props;
        let {roleList} = this.state;
        let selectRole = [];
        if (roleList && roleList.length > 0) {
            roleList.map(item => {
                selectRole.push(
                    <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
                )
            })
        }
        return (
            <>
                <Form ref={(o) => this.form = o} className="add-form margin-bottom" labelAlign='right'
                      labelCol={{span: 4}}
                      wrapperCol={{span: 18}}>
                    <Form.Item label="角色" style={{display: isEdit ? 'none' : null}} name="roleIds"
                               rules={[{required: !isEdit, message: '角色不能为空'}]}>
                        <Select placeholder="请选择" allowClear mode={"multiple"}>
                            {selectRole}
                        </Select>
                    </Form.Item>
                    <Form.Item label="账号" style={{display: isEdit ? 'none' : null}} name="account"
                               rules={[{required: !isEdit, message: '用户名不能为空'}]}>
                        <Input placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item label="密码" style={{display: isEdit ? 'none' : null}} name="pwd"
                               rules={[{required: !isEdit, message: '密码不能为空'}]}>
                        <Input.Password placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item label="确认密码" style={{display: isEdit ? 'none' : null}} name="pwd1"
                               rules={[{required: !isEdit, message: '请确认密码'}]}>
                        <Input.Password placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item label="姓名" name="name" rules={[{required: true, message: '姓名不能为空'}]}>
                        <Input placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item label="联系电话" name="mobile" rules={[{required: true, message: '联系电话不能为空'}]}>
                        <Input placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item label="电子邮箱" name="email">
                        <Input placeholder="请输入" autoComplete="off"/>
                    </Form.Item>
                    <Form.Item style={{display: 'none'}} label="员工ID" name="staffName">
                        <Input/>
                    </Form.Item>
                </Form>
            </>
        )
    }
}
